export enum PortDirection {
  input = "input",
  output = "output"
}
